<template>
  <div class="iphone-x-wrappper">
    <h1>{{ previewType }}</h1>
    <div class="device device-iphone-x">
      <div class="device-frame">
        <div class="hide-scroll">
          <iframe
            class="device-content"
            style="width: 391px"
            :src="`${url}/mobile/${hotelID}/${guestPhase}`"
          >
          </iframe>
        </div>
        <div class="device-btns"></div>
        <div class="device-stripe"></div>
        <div class="device-power"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hotelID: this.$hotelId,
      guestPhase: this.$route.params.guestPhase,
      url: this.$hardcodedPath,
    };
  },
  computed: {
    previewType() {
      switch (this.guestPhase) {
        case "precheckin":
          return "Pre-Checkin";
        case "checkin":
          return "Checked-in";
        case "anonymous":
          return "From QR Code";
        default:
          return "From QR Code";
      }
    },
  },
};
</script>

<style scoped>
.hide-scroll {
  overflow: hidden;
  border-radius: 40px;
}

h1 {
  font-weight: 100;
  text-align: center;
}
.iphone-x-wrappper .device-iphone-x {
  margin: 0 auto;
}
/*! Devices.css v0.1.16 | MIT License | github.com/picturepan2/devices.css */
.device,
.device *,
.device ::after,
.device ::before,
.device::after,
.device::before {
  display: block;
  box-sizing: border-box;
}
.device {
  position: relative;
  transform: scale(1);
  z-index: 1;
}
.device .device-frame {
  z-index: 1;
}

.device-content::-webkit-scrollbar {
  display: none;
}

.device .device-content {
  background-color: #fff;
  position: relative;
}

.device-iphone-x {
  height: 868px;
  /* width: 428px; with scrollbar */
  width: 448px;
}
.device-iphone-x .device-frame {
  background: #222;
  border-radius: 68px;
  box-shadow: inset 0 0 2px 2px #c8cacb, inset 0 0 0 7px #e2e3e4;
  height: 868px;
  padding: 28px;
  /* width: 428px; with scrollbar*/
  width: 448px;
}
.device-iphone-x .device-content {
  border-radius: 40px;
  height: 812px;
  width: 375px;
  pointer-events: all !important;
}
.device-iphone-x .device-stripe::after,
.device-iphone-x .device-stripe::before {
  border: solid rgba(51, 51, 51, 0.25);
  border-width: 0 7px;
  content: "";
  height: 7px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 9;
}
.device-iphone-x .device-stripe::after {
  top: 85px;
}
.device-iphone-x .device-stripe::before {
  bottom: 85px;
}
.device-iphone-x .device-btns {
  background: #c8cacb;
  height: 32px;
  left: -3px;
  position: absolute;
  top: 115px;
  width: 3px;
}
.device-iphone-x .device-btns::after,
.device-iphone-x .device-btns::before {
  background: #c8cacb;
  content: "";
  height: 62px;
  left: 0;
  position: absolute;
  width: 3px;
}
.device-iphone-x .device-btns::after {
  top: 60px;
}
.device-iphone-x .device-btns::before {
  top: 140px;
}
.device-iphone-x .device-power {
  background: #c8cacb;
  height: 100px;
  position: absolute;
  right: -3px;
  top: 200px;
  width: 3px;
}
</style>
